/**
 *
 * @param pack
 * @param name
 * @returns {{element_text: (*|string), element_type: string, element_code}}
 */

export function createEmojiElement(pack, name) {
  const element = pack?.icons.find((icon) => icon.name === name);
  return {
    element_type: 'emoji', // тип элемента
    element_code: name, // Код либо название эмоджи
    element_text: element?.id?.toString() ?? '', // ID эмоджи, если существует (поле типа string)
  };
}
